import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";

import { Stack } from "@mui/material";
import { HorizontalNavBar } from "components";
import { Routes } from "constants/routes";
import { useNavigate } from "hooks";

import { CombinedAmortizationTable } from "./CombinedAmortizationTable";
import { ExpectedPayments } from "./ExpectedPayments";

export const DebtPayments: React.FC = () => {
  const navigate = useNavigate();

  const goToExpectedPayments = () => {
    navigate({ route: "expectedPayments", setQueriesMethod: "replace" });
  };

  const goToAmortizationTable = () => {
    navigate({ route: "debtAmortizationTable", setQueriesMethod: "replace" });
  };

  return (
    <Stack sx={{ width: "100%", height: "100%", overflowY: "hidden", gap: "16px" }}>
      <HorizontalNavBar
        tabs={[
          {
            value: "expected",
            label: "Expected Payments",
            onClick: goToExpectedPayments,
            matchRouts: [Routes.expectedPayments]
          },
          {
            value: "amortization",
            label: "Amortization Table",
            onClick: goToAmortizationTable,
            matchRouts: [Routes.debtAmortizationTable]
          }
        ]}
      />
      <Stack sx={{ flexGrow: 1, overflow: "hidden", padding: "2px" }}>
        <Switch>
          <Route path={Routes.debtAmortizationTable} render={() => <CombinedAmortizationTable />} />
          <Route path={Routes.expectedPayments} render={() => <ExpectedPayments />} />
          <Redirect exact from={Routes.debtPayments} to={Routes.expectedPayments} />
        </Switch>
      </Stack>
    </Stack>
  );
};
